// filepath: c:\\Users\\minmi\\OneDrive\\Desktop\\Emergent-AI-Watch-ID-main\\frontend\\src\\components\\Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

const Header = () => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-gray-900 text-white sticky top-0 z-50" style={{ marginBottom: '0' }}>
      <div className="container mx-auto px-6 flex justify-between items-center">
        <h1 className="text-2xl font-extrabold tracking-wide" style={{ fontFamily: 'Montserrat, Arial, sans-serif', color: '#FFD700', letterSpacing: '2px', textShadow: '0 2px 8px #333' }}>
          <Link to="/">WATCH VERIFIER</Link>
        </h1>
        <nav className="hidden md:flex items-center space-x-4">
          <Link to="/" className="hover:text-gold transition duration-300">{t('Home')}</Link>
          <Link to="/members-area" className="hover:text-gold transition duration-300">{t('Members Area')}</Link>
          <Link to="/cookie-policy" className="hover:text-gold transition duration-300">{t('cookie_policy')}</Link>
          <button
            onClick={() => window.location.href = '/login'}
            className="bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition"
          >
            {t('login')}
          </button>
          <button
            onClick={() => window.location.href = '/register'}
            className="bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition"
          >
            {t('register')}
          </button>
          <div className="flex items-center h-full px-2 py-0 rounded-lg bg-white bg-opacity-0" style={{ marginTop: '4mm' }}>
  <LanguageSelector />
          </div>
        </nav>
        <div className="md:hidden">
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-600 focus:outline-none">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}></path>
            </svg>
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-gray-800 py-2">
          <Link to="/" className="block px-6 py-2 hover:bg-gray-700 hover:text-gold transition duration-300" onClick={() => setIsMenuOpen(false)}>{t('Home')}</Link>
          <Link to="/members-area" className="block px-6 py-2 hover:bg-gray-700 hover:text-gold transition duration-300" onClick={() => setIsMenuOpen(false)}>{t('Members Area')}</Link>
          <Link to="/cookie-policy" className="block px-6 py-2 hover:bg-gray-700 hover:text-gold transition duration-300" onClick={() => setIsMenuOpen(false)}>{t('cookie_policy')}</Link>
          <div className="px-6 py-2">
            <button
              onClick={() => { window.location.href = '/login'; setIsMenuOpen(false); }}
              className="w-full text-left bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition mb-2"
            >
              {t('login')}
            </button>
            <button
              onClick={() => { window.location.href = '/register'; setIsMenuOpen(false); }}
              className="w-full text-left bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition"
            >
              {t('register')}
            </button>
          </div>
          <div className="px-6 py-2">
            <LanguageSelector />
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
